import { useSelector } from "react-redux";
import { partnerActiveSelector } from "../../Reducers/partnerActiveReducer";
import { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export function useLoginSuccess() {
    const passMatched = useSelector(state => state.passMatched);
    const partnerActive = useSelector(partnerActiveSelector);
    const history = useHistory();

    useEffect(() => {
        if (passMatched && partnerActive !== null) {
            if (partnerActive.active) history.push("/partner-portal");
            else history.push("/partner-portal/welcome");
        }
    }, [partnerActive, passMatched, history]);

    return passMatched;
}